(() => {
  let queued = false;
  function arrange() {
    document.querySelectorAll('product-page .product-card').forEach(card => {
      // SA Variants headings are injected asynchronously; prefer their size group.
      const saGroup = [...card.querySelectorAll('[option-name]')].find(el => /^(maat|size)$/i.test(el.getAttribute('option-name')));
      const heading = saGroup?.querySelector('legend') || [...card.querySelectorAll('.product-variant__group-label')].find(el => /^(maat|size)$/i.test(el.textContent.trim()));
      const chart = card.querySelector('.ks-chart-container');
      if (heading && chart) {
        let row = heading.closest('.lr-option-heading');
        if (!row) {
          row = document.createElement('div'); row.className = 'lr-option-heading';
          if (heading.tagName === 'LEGEND') { heading.appendChild(row); while (heading.firstChild !== row) row.appendChild(heading.firstChild); }
          else { heading.before(row); row.appendChild(heading); }
        }
        if (!row.contains(chart)) row.appendChild(chart);
      }
      const form = card.querySelector('product-form');
      const wish = card.querySelector('.shopify-app-block:has(.wl-btn)');
      if (form && wish) {
        let row = form.closest('.lr-buy-row');
        if (!row) { row = document.createElement('div'); row.className = 'lr-buy-row'; form.before(row); row.appendChild(form); }
        if (wish.parentElement !== row) row.appendChild(wish);
      }
    });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(() => { queued = false; arrange(); }); } }
  arrange();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
})();
